module.exports = __webpack_public_path__ + "8efddd9ab8e16dd0dd4cb7d17746869a.fbx";